module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_kristinehamn-a32f4329bf3c40d9c95d29a7409a3532.png";